<template>
    <div>
        <header3 :title="title" />
        <div class = "content_obnovitdate" v-if="!loading" >
            <div>
                <table width="80%">
                    <tr>
                        <td><div class="textcomment"><span >VIN:</span></div></td>
                        <td align="right"><div class="textbalans" ><span >{{ vin }}</span></div></td>
                    </tr>
                </table>
                <hr/>
                <table width="80%">
                    <tr>
                        <td><div class="textcomment"><span >В кошельке:</span></div></td>
                        <td align="right"><div class="textbalans" ><span >{{ balans }} cомон.</span></div></td>
                    </tr>
                </table>
                <hr/>
                <table width="80%">
                    <tr>
                        <td><div class="textcomment"><span >К оплате:</span></div></td>
                        <td align="right"><div class="textbalans" ><span >{{ senavin }} cомон.</span></div></td>
                    </tr>
                </table>
                <hr/>
                <div>
                    <span>Укажите номера WhatsApp, и мы отправим вам полный отчёт о проверке VIN в формате PDF.</span>
                    <div class="container">
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"/></svg>
                      <input type="text" v-model.trim="whatsapp" placeholder="Whatsapp"
                       id="whatsapp" name="whatsapp" autocomplete="whatsapp">
                    </div>
                </div>
             
                
            </div>
            <div id="myModal" class="modal" v-if="goto" >
                <div class="modal-content">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                    <path fill="currentColor" d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z"/></svg>
                    <p><b>Ваш запрос принят.</b><br/>
                    Пожалуйста, подождите, мы отправим результат отчета по VIN на WhatsApp. <br/>
                    Это займет от 10 минут до часа.</p>
                    <a href="/"><button class="btns" >Понятно</button></a>
                
                </div>

            </div>

            
            <div><button class = "buttonviptop" @click="funckupitreportvin()">Купить полный отчёт</button></div>

        </div>
        <br/><br/><br/><br/>
        <div v-if="loading" align="center"><Spinner /></div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import header3 from "../blocks/header3";
  import Spinner from "../blocks/spinner";
  export default {
     components:{
        header3, Spinner,
     },
    data() {
      return {
        vin:"",
        title:"Купить полный отчёт",
        senavin:0,
        balans:0,
        loading:false,
        whatsapp:"+992",
        goto:false,

      
      };
    },
    methods: {
        getinfovin(){
        this.loading = true;
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/getinfovin",
          data: {
            token: localStorage.getItem("token"),
          },
        })
          .then((res) => {
            if (res.data.status) {
               this.loading=false;
               this.senavin=res.data.senavin;
               this.balans=res.data.balans;
            }else{
                alert("Вы уже отправили запрос на отчет по VIN. Подождите, мы отправим вам результат отчета в WhatsApp.");
                this.$router.go(-1);
            }  
          })
          .catch((error) => {
            if (!error.response) {
              alert("Error")
            }
          });
       },


       funckupitreportvin(){
            if(this.senavin > this.balans){
                this.$router.push({ name: "fillupbalans" });
            }else{
                if(this.whatsapp.length < 12){
                    alert("Укажите номера WhatsApp");
                }else{
                    this.addzakazvin();   
                }
                
            }
       },

       addzakazvin(){
        this.loading = true;
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/addzakazvin",
          data: {
            vin: this.vin,
            whatsapp:this.whatsapp,
            token: localStorage.getItem("token"),

          },
        })
          .then((res) => {
            if (res.data.status) {
               this.loading=false;
               localStorage.removeItem("vin");
               this.goto=true;
            }else alert("Error") 
          })
          .catch((error) => {
            if (!error.response) {
              alert("Error")
            }
          });
       },



    },
    created() {
      if (!localStorage.getItem("token")) {
         this.$router.go(-1); 
        }else{
            if(localStorage.getItem("vin")){
              this.vin=localStorage.getItem("vin");
              this.getinfovin();
            }else this.$router.go(-1); 
        } 
    },
    mounted (){
     
    }
  };
  </script>
  <style scoped>
  .content_obnovitdate{
    width: 100%;
    max-width: 400px;
    margin-top: 60px;
    padding-top: 20px;
    margin-bottom: 20px;
    
  }
  .titleviptop{
    margin-top: 5px;
    color: #222;
    font-size: 18px;
  }
  .buttonviptop{
    background: none;
    background-color: #0b76ef;
    padding: 14px 12px;
    border: none;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    width: 100%;
  }
  .buttonviptop:hover{
    background-color: #1381fd;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0);
    cursor: pointer;
  }
  .container {
  display: flex;
  align-items: center; 
  border: 1px solid #393D48;
  border-radius: 5px;
  background-color: #fff;
  margin-top: 10px;
}

.container input[type="text"] {
  flex: 1; 
  padding: 10px; 
  font-size: 18px;
  border: none;
  border-radius: 0px 5px 5px 0px;
}

.container svg {
  padding: 10px;
  color: rgb(25, 204, 75);
}
  .textcomment{
    color: #666;
    font-size: 18px;
  }
  .textbalans{
    color: #000;
    font-size: 18px;
  }
  .modal {
    display: block; 
    position: fixed; 
    z-index: 1; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background-color: rgba(0,0,0,0.4); 
    justify-content: center; /* Выравнивание по центру */
    align-items: center; /* Выравнивание по центру */
    display: flex; /* Использование flexbox для центрирования */
}

.modal-content {
    background-color: #fefefe;
    padding: 20px;
    border: 1px solid #888;
    width: 80%; 
    max-width: 600px; /* Максимальная ширина */
    text-align: center;
    color: #333;
    border-radius: 10px;
}
.modal-content svg{
    color: green;
}
.modal-content p{
    text-align: left;
}
  </style>